module.exports = __webpack_public_path__ + "img/newsletter_jobmule.f5188f2a.png";